export default "__VITE_ASSET__DNvdbMjr__"